<template>
  <div class="service-card-headline mr-auto mb-0">
    <label class="mb-0 d-sm-inline-block">
      <b-form-checkbox v-model="checked">
        <p class="mr-auto mb-0">
          {{ service.text.title }} {{ service.prices.priceInclVAT | formatCurrency }},- {{ content.incl_21_vat }}
          <a
            class="info-symbol"
            role="button"
            :data-info-popup="getIconId(service.translationKey)"
            @click.prevent="setPopupContent(service.prices)"
          ></a>
        </p>
      </b-form-checkbox>
    </label>
  </div>
</template>

<script>
export default {
  name: 'ProductsServicesCheckbox',
  props: ['service'],
  computed: {
    checked: {
      get() {
        return this.$store.getters.productsServices.some(
          (s) => s.productId === this.service.productId
        )
      },
      set(selected) {
        this.$store.commit('TOGGLE_SERVICE_PRODUCTS_SERVICES', {
          service: this.serviceFormatted,
          selected,
        })
      },
    },
    serviceFormatted() {
      return {
        productId: this.service.productId,
        text: this.service.text,
        priceInclVAT: this.service.prices.priceInclVAT,
        priceExclVAT: this.service.prices.priceExclVAT,
        translationKey: this.service.translationKey,
      }
    },
  },
  methods: {
    getIconId(translationKey) {
      //TODO This exception should be changed if we can simplify the content keys for products and services
      if (translationKey.startsWith('cleaning')) return 'cleaning-panels'
      else return translationKey
    },
    setPopupContent(content) {
      this.$store.commit('SET_POPUP_CONTENT', content)
    },
  },
}
</script>
